import React from 'react';

import { Button as AntdButton, Button } from 'antd';

import {
  AvailablePieceJointeDto,
  DossierDtoAdminFonctionnel,
} from 'lib_api/lib/api/gen';

import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';

import BaseModal from '../../../WrappedComponents/BaseModal';

import './DeletePieceJointeModal.less';

interface DeletePieceJointeModalProps {
  isVisible: boolean;
  isLoading: boolean;
  closeModal: () => void;
  confirmDelete: (id: string) => void;
  pieceJointe: AvailablePieceJointeDto;
  dossier: DossierDtoAdminFonctionnel;
}

export const DeletePieceJointeModal = ({
  isVisible,
  isLoading,
  closeModal,
  pieceJointe,
  dossier,
  confirmDelete,
}: DeletePieceJointeModalProps) => {
  return (
    <BaseModal
      width={BaseModalWidthUtils.mediumWidth}
      isVisible={isVisible}
      closeModal={closeModal}
    >
      <div className={'delete-piece-jointe-modal'}>
        <div>
          Supprimer la piece jointe <b>{pieceJointe.libelle}</b> pour
          l&apos;immatriculation&nbsp;<b>{dossier.immatriculation}</b> ?
        </div>
        <p>
          <b>Attention : </b> Cette action est irréversible.
        </p>
        <div className={'delete-piece-jointe-modal-buttons-container'}>
          <Button onClick={closeModal}>Annuler</Button>
          <AntdButton
            disabled={false}
            onClick={() => {
              confirmDelete(pieceJointe.identifiant);
            }}
            loading={isLoading}
            type="primary"
          >
            Confirmer
          </AntdButton>
        </div>
      </div>
    </BaseModal>
  );
};
